import { FilterHeader } from "./FilterHeader"
import { InfiniteScroll, Input, Popup, SearchBar, SpinLoading } from 'antd-mobile'
import { SearchConditionsResponseItemLabel } from "@/component/FilterCommon/hooks/useSearchCondition"
import { styled } from "styled-components"
import React from 'react'
import { DownFill,CheckOutline,LeftOutline } from 'antd-mobile-icons'
import { throttle,debounce } from "lodash"
import { getAppSafeTopArea } from "@/utils/utils"


const FilterListView = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #F7F7F7;
  height: 100%;
  .list-body{
    flex: 1;
    overflow-y: auto;
    margin: 10px;
    background-color: #fff;
    border-radius: 8px;
    padding: 10px;
    .list-item-wrap{
      display: flex;
      align-items: center;
      .list-item{
        flex: 1;
        overflow: hidden;
      }
      
    }
    .list-item{
      height: 50px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #efefef;
    }
  }
  .search .adm-search-bar-input-box{
    background-color: #fff;
    margin: 0 10px;
  }
  .search{
    margin-top: 10px;
  }


`



export interface FilterListProps<T> {
  dataSource: T[]
  value?:(string|number)[]
  onChange?(value:(string|number)[]):void
  visible?:boolean
  onClose?():void
  setKw?(kw:string):void
  loadMore?:()=>Promise<void>
  hasMore?:boolean
  loading?:boolean
  headerText?: React.ReactNode
  hideSearch?:boolean
  renderItem?: (renderOptions:{item: T, index: number, list: T[],isChecked:boolean,onChange:(value:T)=>void }) => React.ReactNode
  addAllChildren?:boolean
}


export const FilterList = <T extends SearchConditionsResponseItemLabel >(props:FilterListProps<T>)=>{
  const { loadMore ,hasMore = false,value = [],headerText = '',loading} = props;

  // const [list,setList] = React.useState<T[]>([])
  // React.useEffect(()=>{
  //   setList(props.dataSource)
  // },[props.dataSource])
  let list =  props.dataSource
  const [ kw,setKw ] = React.useState<any>()

  const renderLoading = ()=>{
    let emptyView =  <div style={{textAlign:'center'}}>暂无数据</div>
    let isEmptyList = !list.length
    if(isEmptyList){
      if(props.loading){
        // return <div style={{display:"flex",justifyContent:'center'}}><SpinLoading style={{fontSize:10}} /></div>
        return <div style={{display:"flex",justifyContent:'center'}}>加载中...</div>
      }else{
        return emptyView
      }
    }
    return null
  }
  const getAllChildrenValues = (item: T): (string|number)[] => {
    const values: (string|number)[] = []
    const collect = (node: T) => {
      if (node.children) {
        for (const child of node.children) {
          values.push(child.value)
          collect(child as T)
        }
      }
    }
    collect(item)
    return values
  }

  const onChange = (current:T)=>{
    if (props.addAllChildren) {
      onChangeWithChildren(current)
      return
    }
    let _value = [...value]
    let index = _value.findIndex(item => item == current.value)
    if(index > -1){
      _value.splice(index,1)
    }else{
      _value.push(current.value)
    }
    props?.onChange?.(_value)
  }
  //  报表那边超过 4000 个会报错。
  const MAX_VALUES = 3500

  const onChangeWithChildren = (current: T) => {
    let _value = [...value]
    const allValues = [current.value, ...getAllChildrenValues(current)]
    const isRemoving = _value.includes(current.value)
    if (isRemoving) {
      const removeSet = new Set(allValues)
      _value = _value.filter(v => !removeSet.has(v))
    } else {
      const existingSet = new Set(_value)
      for (const v of allValues) {
        if (_value.length >= MAX_VALUES) break
        if (!existingSet.has(v)) {
          _value.push(v)
          existingSet.add(v)
        }
      }
    }
    props?.onChange?.(_value)
  }
  const renderItem = (item: T, index: number,list: T[]) => {
    let isChecked = !!value.find(val => val == item.value)
    if(props.renderItem){
      return props.renderItem({item,index,list,isChecked,onChange})
    }
    return <div className={`list-item-wrap`}>
      <div key={index} className="list-item" onClick={() => onChange(item)}>
        {item.label}
      </div>
      { isChecked &&  <CheckOutline className='check-arrow' fontSize={20} color="#3487ed" />  }
    </div>
  }
  const onLoadMore = async ()=>{
    if(loadMore){
      await loadMore();
      return
    }
  }
  const setKwDebounce = React.useRef(debounce((kw:string)=>{
    props?.setKw?.(kw)
  },1000,{trailing:true}));
  const onChangeKw = async (kw:string)=>{
    setKw(kw);
    setKwDebounce.current(kw)
  }

  let _list = list
  if(kw !== undefined && !loadMore){
    _list = list.filter(item => item.label.includes(kw))
  }
  let paddingTop = getAppSafeTopArea()
  return <Popup
    position='right'
    closeOnMaskClick
    destroyOnClose
    bodyStyle={{ width: '100%' }}
    visible={props.visible}
    onClose={props?.onClose}
  >
    <FilterListView >
      <FilterHeader onClose={ props.onClose } text={headerText}   />
      { !props.hideSearch && <SearchBar placeholder="搜索" value={kw} className="search" onChange={(val) => onChangeKw(val)} clearable /> }
      <div className="list-body">
        {_list.map((item, index,) => {
          return renderItem(item,index,_list)
        })}
        { renderLoading() }
        { loadMore  && <InfiniteScroll loadMore={ onLoadMore } hasMore={hasMore}/> }
      </div>
    </FilterListView>
  </Popup>
}